import { createSlice } from "@reduxjs/toolkit";
import {  userFavNonprofitsAPI } from "../../../api/publicApi";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const userFavNonprofitsSlice = createSlice({
  name: "userFavNonprofits",
  initialState: data,
  reducers: {
    userFavNonprofitsSlice(state) {
      state.isLoading = true;
    },
    userFavNonprofitsSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = null;
    },
    userFavNonprofitsSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
    },
    userFavNonprofitsSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});

export const userFavNonprofitsHandler = (user_id:string) => async (dispatch: any) => {
  try {
    dispatch(userFavNonprofitsAction.userFavNonprofitsSlice());
    const response: any = await userFavNonprofitsAPI(user_id);
    dispatch(userFavNonprofitsAction.userFavNonprofitsSliceSuccess(response));
  } catch (e: any) {
    dispatch(userFavNonprofitsAction.userFavNonprofitsSliceFailure(e?.response?.data?.message));
    dispatch(userFavNonprofitsAction.userFavNonprofitsSliceReset());
  }
};
export default userFavNonprofitsSlice.reducer;
export const userFavNonprofitsAction = userFavNonprofitsSlice.actions;
